import { render, staticRenderFns } from "./lazyblock_subtitle.vue?vue&type=template&id=4867a17e&scoped=true"
import script from "./lazyblock_subtitle.vue?vue&type=script&lang=js"
export * from "./lazyblock_subtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867a17e",
  null
  
)

export default component.exports